// extracted by mini-css-extract-plugin
export default {"warning":"deletePopup_warning__Ku7IZ","button":"deletePopup_button__R+WkJ"};